const ANON_ID_KEY = 'wk_anon_id';

export function getOrCreateAnonId() {
  let id = null;
  try {
    id = localStorage.getItem(ANON_ID_KEY);
  } catch (e) { /* localStorage disabled */ }
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    try { localStorage.setItem(ANON_ID_KEY, id); } catch (e) { /* noop */ }
  }
  return id;
}

function fnv1a(input) {
  let hash = 2166136261 >>> 0;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  hash ^= hash >>> 16;
  hash = Math.imul(hash, 0x7feb352d) >>> 0;
  hash ^= hash >>> 15;
  hash = Math.imul(hash, 0x846ca68b) >>> 0;
  hash ^= hash >>> 16;
  return hash >>> 0;
}

export function bucket(anonId, experimentName, variants) {
  const idx = fnv1a(`${anonId}:${experimentName}`) % variants.length;
  return variants[idx];
}
